// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 256 256%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noise%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.8%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23noise%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
    --background: 0 0% 100%;
    --foreground: 0 0% 3.9%;
    --card: 0 0% 100%;
    --card-foreground: 0 0% 3.9%;
    --popover: 0 0% 100%;
    --popover-foreground: 0 0% 3.9%;
    --primary: 0 0% 9%;
    --primary-foreground: 0 0% 98%;
    --secondary: 0 0% 96.1%;
    --secondary-foreground: 0 0% 9%;
    --muted: 0 0% 96.1%;
    --muted-foreground: 0 0% 45.1%;
    --accent: 0 0% 96.1%;
    --accent-foreground: 0 0% 9%;
    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 0 0% 98%;
    --border: 0 0% 89.8%;
    --input: 0 0% 89.8%;
    --ring: 0 0% 3.9%;
    --chart-1: 12 76% 61%;
    --chart-2: 173 58% 39%;
    --chart-3: 197 37% 24%;
    --chart-4: 43 74% 66%;
    --chart-5: 27 87% 67%;
    --radius: 0.5rem;
  }

*{
  border-color: hsl(var(--border));
}

/* Override shadcn default body to keep the dark crypto theme */

body {
    background-color: #0a0b0d;
    color: #D5D5D0;
  }
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
@media (min-width: 1920px){

  .container{
    max-width: 1920px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-1{
  left: -0.25rem;
}
.-left-12{
  left: -3rem;
}
.-left-32{
  left: -8rem;
}
.-left-4{
  left: -1rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-12{
  right: -3rem;
}
.-right-3{
  right: -0.75rem;
}
.-right-4{
  right: -1rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-12{
  top: -3rem;
}
.-top-3{
  top: -0.75rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1\\/4{
  bottom: 25%;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-1\\/4{
  left: 25%;
}
.left-2{
  left: 0.5rem;
}
.left-6{
  left: 1.5rem;
}
.left-8{
  left: 2rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\/4{
  right: 25%;
}
.right-2{
  right: 0.5rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-1\\/3{
  top: 33.333333%;
}
.top-1\\/4{
  top: 25%;
}
.top-10{
  top: 2.5rem;
}
.top-2\\/4{
  top: 50%;
}
.top-28{
  top: 7rem;
}
.top-3\\/4{
  top: 75%;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.-z-10{
  z-index: -10;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}
.row-span-1{
  grid-row: span 1 / span 1;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-14{
  margin-bottom: 3.5rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-16{
  margin-left: 4rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[160px\\]{
  height: 160px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[190px\\]{
  height: 190px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[240px\\]{
  height: 240px;
}
.h-\\[260px\\]{
  height: 260px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[360px\\]{
  height: 360px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[420px\\]{
  height: 420px;
}
.h-\\[480px\\]{
  height: 480px;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[97px\\]{
  height: 97px;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[100svh\\]{
  min-height: 100svh;
}
.min-h-\\[140px\\]{
  min-height: 140px;
}
.min-h-\\[280px\\]{
  min-height: 280px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[114px\\]{
  width: 114px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[190px\\]{
  width: 190px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[240px\\]{
  width: 240px;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[32\\%\\]{
  width: 32%;
}
.w-\\[34\\%\\]{
  width: 34%;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-\\[480px\\]{
  width: 480px;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[520px\\]{
  width: 520px;
}
.w-\\[600px\\]{
  width: 600px;
}
.w-\\[800px\\]{
  width: 800px;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[112px\\]{
  min-width: 112px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[860px\\]{
  min-width: 860px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-7xl{
  max-width: 90rem;
}
.max-w-\\[104px\\]{
  max-width: 104px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-1{
  flex: 1 1;
}
.flex-\\[2\\]{
  flex: 2 1;
}
.flex-\\[3\\]{
  flex: 3 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-150{
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\]{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[2\\]{
  --tw-scale-x: 2;
  --tw-scale-y: 2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping{

  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize{
  resize: both;
}
.list-none{
  list-style-type: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-16 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(4rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(4rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#9C7941\\]\\/10 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(156 121 65 / 0.1);
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-bl-3xl{
  border-bottom-left-radius: 1.5rem;
}
.rounded-bl-xl{
  border-bottom-left-radius: 0.75rem;
}
.rounded-br-3xl{
  border-bottom-right-radius: 1.5rem;
}
.rounded-br-xl{
  border-bottom-right-radius: 0.75rem;
}
.rounded-tl-3xl{
  border-top-left-radius: 1.5rem;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.rounded-tl-xl{
  border-top-left-radius: 0.75rem;
}
.rounded-tr-3xl{
  border-top-right-radius: 1.5rem;
}
.rounded-tr-xl{
  border-top-right-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-2{
  border-right-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-\\[\\#1B1E20\\]{
  --tw-border-opacity: 1;
  border-color: rgb(27 30 32 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1e2028\\]{
  --tw-border-opacity: 1;
  border-color: rgb(30 32 40 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1e2028\\]\\/50{
  border-color: rgb(30 32 40 / 0.5);
}
.border-\\[\\#2a2d35\\]{
  --tw-border-opacity: 1;
  border-color: rgb(42 45 53 / var(--tw-border-opacity, 1));
}
.border-\\[\\#4A4B50\\]{
  --tw-border-opacity: 1;
  border-color: rgb(74 75 80 / var(--tw-border-opacity, 1));
}
.border-\\[\\#4A4B50\\]\\/20{
  border-color: rgb(74 75 80 / 0.2);
}
.border-\\[\\#4A4B50\\]\\/30{
  border-color: rgb(74 75 80 / 0.3);
}
.border-\\[\\#9C7941\\]{
  --tw-border-opacity: 1;
  border-color: rgb(156 121 65 / var(--tw-border-opacity, 1));
}
.border-\\[\\#9C7941\\]\\/10{
  border-color: rgb(156 121 65 / 0.1);
}
.border-\\[\\#9C7941\\]\\/20{
  border-color: rgb(156 121 65 / 0.2);
}
.border-\\[\\#9C7941\\]\\/25{
  border-color: rgb(156 121 65 / 0.25);
}
.border-\\[\\#9C7941\\]\\/30{
  border-color: rgb(156 121 65 / 0.3);
}
.border-\\[\\#9C7941\\]\\/35{
  border-color: rgb(156 121 65 / 0.35);
}
.border-\\[\\#9C7941\\]\\/40{
  border-color: rgb(156 121 65 / 0.4);
}
.border-\\[\\#9C7941\\]\\/50{
  border-color: rgb(156 121 65 / 0.5);
}
.border-\\[\\#EBD38D\\]{
  --tw-border-opacity: 1;
  border-color: rgb(235 211 141 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EBD38D\\]\\/10{
  border-color: rgb(235 211 141 / 0.1);
}
.border-\\[\\#EBD38D\\]\\/50{
  border-color: rgb(235 211 141 / 0.5);
}
.border-blue-500\\/30{
  border-color: rgb(59 130 246 / 0.3);
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-green-500\\/20{
  border-color: rgb(34 197 94 / 0.2);
}
.border-green-500\\/25{
  border-color: rgb(34 197 94 / 0.25);
}
.border-green-500\\/30{
  border-color: rgb(34 197 94 / 0.3);
}
.border-input{
  border-color: hsl(var(--input));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500\\/40{
  border-color: rgb(239 68 68 / 0.4);
}
.border-transparent{
  border-color: transparent;
}
.border-violet-500\\/30{
  border-color: rgb(139 92 246 / 0.3);
}
.border-white\\/5{
  border-color: rgb(255 255 255 / 0.05);
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#0a0b0d\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 11 13 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0a0b0d\\]\\/50{
  background-color: rgb(10 11 13 / 0.5);
}
.bg-\\[\\#0a0b0d\\]\\/60{
  background-color: rgb(10 11 13 / 0.6);
}
.bg-\\[\\#0a0b0d\\]\\/90{
  background-color: rgb(10 11 13 / 0.9);
}
.bg-\\[\\#0a0b0d\\]\\/95{
  background-color: rgb(10 11 13 / 0.95);
}
.bg-\\[\\#0d0f14\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(13 15 20 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0d0f14\\]\\/80{
  background-color: rgb(13 15 20 / 0.8);
}
.bg-\\[\\#0d0f14\\]\\/95{
  background-color: rgb(13 15 20 / 0.95);
}
.bg-\\[\\#0f1012\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 16 18 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#12141a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(18 20 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#12141a\\]\\/50{
  background-color: rgb(18 20 26 / 0.5);
}
.bg-\\[\\#12141a\\]\\/60{
  background-color: rgb(18 20 26 / 0.6);
}
.bg-\\[\\#12141a\\]\\/80{
  background-color: rgb(18 20 26 / 0.8);
}
.bg-\\[\\#12141a\\]\\/90{
  background-color: rgb(18 20 26 / 0.9);
}
.bg-\\[\\#131517\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(19 21 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1B1E20\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(27 30 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1B1E20\\]\\/50{
  background-color: rgb(27 30 32 / 0.5);
}
.bg-\\[\\#1a1d24\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 29 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e2028\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 32 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22c55e\\]\\/5{
  background-color: rgb(34 197 94 / 0.05);
}
.bg-\\[\\#2a2d35\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(42 45 53 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4A4B50\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(74 75 80 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4A4B50\\]\\/20{
  background-color: rgb(74 75 80 / 0.2);
}
.bg-\\[\\#9C7941\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(156 121 65 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#9C7941\\]\\/10{
  background-color: rgb(156 121 65 / 0.1);
}
.bg-\\[\\#9C7941\\]\\/15{
  background-color: rgb(156 121 65 / 0.15);
}
.bg-\\[\\#9C7941\\]\\/20{
  background-color: rgb(156 121 65 / 0.2);
}
.bg-\\[\\#9C7941\\]\\/25{
  background-color: rgb(156 121 65 / 0.25);
}
.bg-\\[\\#9C7941\\]\\/30{
  background-color: rgb(156 121 65 / 0.3);
}
.bg-\\[\\#9C7941\\]\\/5{
  background-color: rgb(156 121 65 / 0.05);
}
.bg-\\[\\#EBD38D\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(235 211 141 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBD38D\\]\\/10{
  background-color: rgb(235 211 141 / 0.1);
}
.bg-\\[\\#EBD38D\\]\\/15{
  background-color: rgb(235 211 141 / 0.15);
}
.bg-\\[\\#EBD38D\\]\\/20{
  background-color: rgb(235 211 141 / 0.2);
}
.bg-\\[\\#EBD38D\\]\\/5{
  background-color: rgb(235 211 141 / 0.05);
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-500\\/5{
  background-color: rgb(59 130 246 / 0.05);
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-emerald-400\\/80{
  background-color: rgb(52 211 153 / 0.8);
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/10{
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-500\\/15{
  background-color: rgb(34 197 94 / 0.15);
}
.bg-green-500\\/20{
  background-color: rgb(34 197 94 / 0.2);
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[radial-gradient\\(circle_at_center\\2c rgba\\(156\\2c 121\\2c 65\\2c 0\\.18\\)\\2c transparent_65\\%\\)\\]{
  background-image: radial-gradient(circle at center,rgba(156,121,65,0.18),transparent 65%);
}
.bg-\\[radial-gradient\\(ellipse_60\\%_60\\%_at_100\\%_100\\%\\2c rgba\\(235\\2c 211\\2c 141\\2c 0\\.08\\)\\2c transparent\\)\\]{
  background-image: radial-gradient(ellipse 60% 60% at 100% 100%,rgba(235,211,141,0.08),transparent);
}
.bg-\\[radial-gradient\\(ellipse_80\\%_50\\%_at_50\\%_-20\\%\\2c rgba\\(156\\2c 121\\2c 65\\2c 0\\.15\\)\\2c transparent\\)\\]{
  background-image: radial-gradient(ellipse 80% 50% at 50% -20%,rgba(156,121,65,0.15),transparent);
}
.bg-\\[radial-gradient\\(ellipse_80\\%_80\\%_at_50\\%_-20\\%\\2c rgba\\(156\\2c 121\\2c 65\\2c 0\\.15\\)\\2c transparent\\)\\]{
  background-image: radial-gradient(ellipse 80% 80% at 50% -20%,rgba(156,121,65,0.15),transparent);
}
.bg-\\[radial-gradient\\(ellipse_at_center\\2c rgba\\(156\\2c 121\\2c 65\\2c 0\\.15\\)\\2c transparent_70\\%\\)\\]{
  background-image: radial-gradient(ellipse at center,rgba(156,121,65,0.15),transparent 70%);
}
.bg-\\[radial-gradient\\(ellipse_at_top\\2c rgba\\(156\\2c 121\\2c 65\\2c 0\\.1\\)\\2c transparent_60\\%\\)\\]{
  background-image: radial-gradient(ellipse at top,rgba(156,121,65,0.1),transparent 60%);
}
.bg-\\[radial-gradient\\(ellipse_at_top_left\\2c rgba\\(34\\2c 197\\2c 94\\2c 0\\.08\\)\\2c transparent_55\\%\\)\\]{
  background-image: radial-gradient(ellipse at top left,rgba(34,197,94,0.08),transparent 55%);
}
.bg-\\[radial-gradient\\(ellipse_at_top_right\\2c rgba\\(156\\2c 121\\2c 65\\2c 0\\.12\\)\\2c transparent_55\\%\\)\\]{
  background-image: radial-gradient(ellipse at top right,rgba(156,121,65,0.12),transparent 55%);
}
.bg-\\[radial-gradient\\(ellipse_at_top_right\\2c rgba\\(156\\2c 121\\2c 65\\2c 0\\.15\\)\\2c transparent_60\\%\\)\\]{
  background-image: radial-gradient(ellipse at top right,rgba(156,121,65,0.15),transparent 60%);
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#0a0b0d\\]{
  --tw-gradient-from: #0a0b0d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(10 11 13 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#12141a\\]{
  --tw-gradient-from: #12141a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(18 20 26 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#12141a\\]\\/80{
  --tw-gradient-from: rgb(18 20 26 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(18 20 26 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1B1E20\\]{
  --tw-gradient-from: #1B1E20 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(27 30 32 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1a1c22\\]{
  --tw-gradient-from: #1a1c22 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 28 34 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#9C7941\\]{
  --tw-gradient-from: #9C7941 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 121 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#9C7941\\]\\/0{
  --tw-gradient-from: rgb(156 121 65 / 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 121 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#9C7941\\]\\/10{
  --tw-gradient-from: rgb(156 121 65 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 121 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#9C7941\\]\\/20{
  --tw-gradient-from: rgb(156 121 65 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 121 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#9C7941\\]\\/25{
  --tw-gradient-from: rgb(156 121 65 / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 121 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#9C7941\\]\\/5{
  --tw-gradient-from: rgb(156 121 65 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 121 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#D5D5D0\\]{
  --tw-gradient-from: #D5D5D0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(213 213 208 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#EBD38D\\]{
  --tw-gradient-from: #EBD38D var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(235 211 141 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/20{
  --tw-gradient-from: rgb(59 130 246 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500\\/20{
  --tw-gradient-from: rgb(34 197 94 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500\\/20{
  --tw-gradient-from: rgb(139 92 246 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#0f1012\\]{
  --tw-gradient-to: rgb(15 16 18 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0f1012 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#12141a\\]{
  --tw-gradient-to: rgb(18 20 26 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #12141a var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#15171c\\]{
  --tw-gradient-to: rgb(21 23 28 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #15171c var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#1a1c22\\]\\/90{
  --tw-gradient-to: rgb(26 28 34 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(26 28 34 / 0.9) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#1a1d1f\\]{
  --tw-gradient-to: rgb(26 29 31 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1a1d1f var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#9C7941\\]{
  --tw-gradient-to: rgb(156 121 65 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #9C7941 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#9C7941\\]\\/20{
  --tw-gradient-to: rgb(156 121 65 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(156 121 65 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#9C7941\\]\\/30{
  --tw-gradient-to: rgb(156 121 65 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(156 121 65 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#EBD38D\\]{
  --tw-gradient-to: rgb(235 211 141 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #EBD38D var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#0a0b0d\\]{
  --tw-gradient-to: #0a0b0d var(--tw-gradient-to-position);
}
.to-\\[\\#0f1012\\]{
  --tw-gradient-to: #0f1012 var(--tw-gradient-to-position);
}
.to-\\[\\#12141a\\]{
  --tw-gradient-to: #12141a var(--tw-gradient-to-position);
}
.to-\\[\\#12141a\\]\\/80{
  --tw-gradient-to: rgb(18 20 26 / 0.8) var(--tw-gradient-to-position);
}
.to-\\[\\#15171c\\]{
  --tw-gradient-to: #15171c var(--tw-gradient-to-position);
}
.to-\\[\\#1B1E20\\]{
  --tw-gradient-to: #1B1E20 var(--tw-gradient-to-position);
}
.to-\\[\\#1a1c22\\]{
  --tw-gradient-to: #1a1c22 var(--tw-gradient-to-position);
}
.to-\\[\\#4A4B50\\]{
  --tw-gradient-to: #4A4B50 var(--tw-gradient-to-position);
}
.to-\\[\\#9C7941\\]{
  --tw-gradient-to: #9C7941 var(--tw-gradient-to-position);
}
.to-\\[\\#9C7941\\]\\/0{
  --tw-gradient-to: rgb(156 121 65 / 0) var(--tw-gradient-to-position);
}
.to-\\[\\#9C7941\\]\\/30{
  --tw-gradient-to: rgb(156 121 65 / 0.3) var(--tw-gradient-to-position);
}
.to-\\[\\#D5D5D0\\]{
  --tw-gradient-to: #D5D5D0 var(--tw-gradient-to-position);
}
.to-\\[\\#EBD38D\\]{
  --tw-gradient-to: #EBD38D var(--tw-gradient-to-position);
}
.to-\\[\\#EBD38D\\]\\/0{
  --tw-gradient-to: rgb(235 211 141 / 0) var(--tw-gradient-to-position);
}
.to-\\[\\#EBD38D\\]\\/10{
  --tw-gradient-to: rgb(235 211 141 / 0.1) var(--tw-gradient-to-position);
}
.to-\\[\\#EBD38D\\]\\/5{
  --tw-gradient-to: rgb(235 211 141 / 0.05) var(--tw-gradient-to-position);
}
.to-cyan-500\\/10{
  --tw-gradient-to: rgb(6 182 212 / 0.1) var(--tw-gradient-to-position);
}
.to-emerald-500\\/10{
  --tw-gradient-to: rgb(16 185 129 / 0.1) var(--tw-gradient-to-position);
}
.to-purple-500\\/10{
  --tw-gradient-to: rgb(168 85 247 / 0.1) var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.fill-\\[\\#EBD38D\\]{
  fill: #EBD38D;
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[3px\\]{
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[5px\\]{
  padding-top: 5px;
  padding-bottom: 5px;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-28{
  padding-top: 7rem;
}
.pt-32{
  padding-top: 8rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1.0625rem;
  line-height: 1.75;
}
.text-lg{
  font-size: 1.1875rem;
  line-height: 1.75;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.3125rem;
  line-height: 1.75;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[1\\.1\\]{
  line-height: 1.1;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#0a0b0d\\]{
  --tw-text-opacity: 1;
  color: rgb(10 11 13 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1B1E20\\]{
  --tw-text-opacity: 1;
  color: rgb(27 30 32 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2a2d35\\]{
  --tw-text-opacity: 1;
  color: rgb(42 45 53 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A4B50\\]{
  --tw-text-opacity: 1;
  color: rgb(74 75 80 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B6D75\\]{
  --tw-text-opacity: 1;
  color: rgb(107 109 117 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8A8B90\\]{
  --tw-text-opacity: 1;
  color: rgb(138 139 144 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9A9B9F\\]{
  --tw-text-opacity: 1;
  color: rgb(154 155 159 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9C7941\\]{
  --tw-text-opacity: 1;
  color: rgb(156 121 65 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C5C6CB\\]{
  --tw-text-opacity: 1;
  color: rgb(197 198 203 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D5D5D0\\]{
  --tw-text-opacity: 1;
  color: rgb(213 213 208 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EBD38D\\]{
  --tw-text-opacity: 1;
  color: rgb(235 211 141 / var(--tw-text-opacity, 1));
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-green-400{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-400\\/95{
  color: rgb(74 222 128 / 0.95);
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-400\\/95{
  color: rgb(248 113 113 / 0.95);
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-violet-400{
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-\\[0\\.03\\]{
  opacity: 0.03;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.15\\)\\]{
  --tw-shadow: 0 0 20px rgba(156,121,65,0.15);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 0 20px rgba(156,121,65,0.25);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 0 20px rgba(156,121,65,0.3);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 0 20px rgba(156,121,65,0.5);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_30px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.15\\)\\]{
  --tw-shadow: 0 0 30px rgba(156,121,65,0.15);
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_30px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 0 30px rgba(156,121,65,0.3);
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_40px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 0 40px rgba(156,121,65,0.3);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_40px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.4\\)\\2c inset_0_0_30px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 0 40px rgba(156,121,65,0.4),inset 0 0 30px rgba(156,121,65,0.2);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color), inset 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 4px 16px rgba(0,0,0,0.35);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-white\\/20{
  --tw-ring-color: rgb(255 255 255 / 0.2);
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl{
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_0_20px_rgba\\(235\\2c 211\\2c 141\\2c 0\\.5\\)\\]{
  --tw-drop-shadow: drop-shadow(0 0 20px rgba(235,211,141,0.5));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_0_30px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.4\\)\\]{
  --tw-drop-shadow: drop-shadow(0 0 30px rgba(156,121,65,0.4));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_0_50px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.3\\)\\]{
  --tw-drop-shadow: drop-shadow(0 0 50px rgba(156,121,65,0.3));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}
.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
    scrollbar-color: transparent transparent;
    color-scheme: dark;
  }
.scrollbar-hide::-webkit-scrollbar,
  .scrollbar-hide::-webkit-scrollbar-corner {
    width: 0;
    height: 0;
    display: none;
    background: transparent;
  }
.scrollbar-hide::-webkit-scrollbar-thumb,
  .scrollbar-hide::-webkit-scrollbar-track,
  .scrollbar-hide::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
    background: transparent;
  }

/* scrollbar-hide utility (used in trading components) */

/* Order book list classes — see unlayered block at end of file (must win over Tailwind) */

/* Hide Emergent badge */
#emergent-badge {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* PDF print styles */
@media print {
  body {
    background-color: #0a0b0d !important;
    print-color-adjust: exact !important;
  }
  
  .pdf-section {
    page-break-inside: avoid;
  }
}

:root {
  --brand-primary: #9C7941;
  --brand-secondary: #EBD38D;
  --brand-dark: #1B1E20;
  --brand-gray: #4A4B50;
  --brand-silver: #D5D5D0;
  --bg-default: #1B1E20;
  --bg-paper: #232628;
  --text-primary: #FFFFFF;
  --text-secondary: #D5D5D0;
  --text-muted: #8A8B90;
  --text-accent: #EBD38D;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  font-size: 15px;
}

@media (min-width: 640px) {
  html {
    font-size: 16px;
  }
}

@media (min-width: 1280px) {
  html {
    font-size: 17px;
  }
}

@media (max-width: 639px) {
  [id] {
    scroll-margin-top: 88px;
  }
}

body {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  background-color: var(--bg-default);
  color: var(--text-secondary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Outfit', sans-serif;
}

code, pre {
  font-family: 'JetBrains Mono', monospace;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-default);
}

::-webkit-scrollbar-thumb {
  background: var(--brand-gray);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary);
}

/* Selection */
::selection {
  background: var(--brand-primary);
  color: var(--brand-dark);
}

/* Animations */
@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(2deg);
  }
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 0 20px rgba(156, 121, 65, 0.4);
  }
  50% {
    box-shadow: 0 0 40px rgba(156, 121, 65, 0.6);
  }
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes gradient-shift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes ticker {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-pulse-glow {
  animation: pulse-glow 2s ease-in-out infinite;
}

.animate-shimmer {
  background: linear-gradient(90deg, transparent, rgba(235, 211, 141, 0.1), transparent);
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

.animate-gradient {
  background-size: 200% 200%;
  animation: gradient-shift 3s ease infinite;
}

.animate-ticker {
  animation: ticker 30s linear infinite;
}

/* Glass morphism */
.glass {
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  background: rgba(27, 30, 32, 0.7);
  border: 1px solid rgba(235, 211, 141, 0.1);
}

.glass-hover:hover {
  background: rgba(27, 30, 32, 0.85);
  border-color: rgba(235, 211, 141, 0.3);
}

/* Gold gradient text */
.text-gold-gradient {
  background: linear-gradient(135deg, #FFFFFF 0%, #EBD38D 50%, #9C7941 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Gold border glow */
.border-gold-glow {
  border: 1px solid rgba(156, 121, 65, 0.3);
  box-shadow: 0 0 20px rgba(156, 121, 65, 0.15);
}

/* Button styles */
.btn-primary {
  background: linear-gradient(135deg, #9C7941 0%, #EBD38D 100%);
  color: #1B1E20;
  font-weight: 700;
  padding: 1rem 2rem;
  border-radius: 9999px;
  transition: all 0.3s ease;
  box-shadow: 0 0 20px rgba(156, 121, 65, 0.4);
}

.btn-primary:hover {
  transform: scale(1.05);
  box-shadow: 0 0 30px rgba(156, 121, 65, 0.6);
}

.btn-secondary {
  background: transparent;
  border: 2px solid #EBD38D;
  color: #EBD38D;
  font-weight: 700;
  padding: 1rem 2rem;
  border-radius: 9999px;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: rgba(235, 211, 141, 0.1);
}

/*
 * Fixed header height:
 *   announcement strip  ≈ 36px  (h-9)
 *   main nav (scrolled) ≈ 56px  (py-3 + ~40px content)
 *   total               ≈ 92px  → use 100px for buffer
 *
 * All section IDs get scroll-margin-top so the fixed header
 * doesn't cover them when an anchor link scrolls to them.
 */
[id] {
  scroll-margin-top: 100px;
}

/* Section styling */
.section-padding {
  padding: 4rem 1rem;
}

@media (min-width: 640px) {
  .section-padding {
    padding: 5rem 1.5rem;
  }
}

@media (min-width: 1024px) {
  .section-padding {
    padding: 7rem 4rem;
  }
}

@media (min-width: 1280px) {
  .section-padding {
    padding: 8rem 5rem;
  }
}

/* Card styling */
.card-glass {
  background: rgba(27, 30, 32, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(74, 75, 80, 0.3);
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.card-glass:hover {
  border-color: rgba(156, 121, 65, 0.5);
  transform: translateY(-4px);
}

/* Noise overlay */
.noise-overlay::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0.02;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  z-index: 1; /* Keep below modals, dropdowns, and fixed nav (z-50) */
}

/*
 * Order book — Radix ScrollArea injects scrollbar-hiding CSS on the viewport.
 * These rules handle text selection + tap highlight (white “flash” on Windows).
 */
.order-book-root {
  -webkit-tap-highlight-color: transparent;
  color-scheme: dark;
  -webkit-touch-callout: none;
  overflow: hidden;
  min-height: 0;
}

/* Wheel-scroll viewports: no native scrollbar (Windows often shows a bright track otherwise). */
.ob-viewport {
  overflow: hidden !important;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.ob-viewport::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.order-book-row {
  -webkit-tap-highlight-color: transparent;
  contain: layout paint;
}

.order-book-row,
.order-book-row * {
  user-select: none !important;
  -webkit-user-select: none !important;
}

.order-book-root ::selection,
.order-book-root *::selection {
  background: transparent !important;
  color: inherit !important;
}

.order-book-mid {
  user-select: none !important;
  -webkit-user-select: none !important;
  -webkit-tap-highlight-color: transparent;
}

/* Wheel-scroll inner layer (no native overflow = no scrollbar gutter) */
.order-book-wheel-content {
  user-select: none !important;
  -webkit-user-select: none !important;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.placeholder\\:text-\\[\\#4A4B50\\]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(74 75 80 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.focus-within\\:border-\\[\\#9C7941\\]:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(156 121 65 / var(--tw-border-opacity, 1));
}
.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#9C7941\\]\\/30:hover{
  border-color: rgb(156 121 65 / 0.3);
}
.hover\\:border-\\[\\#9C7941\\]\\/40:hover{
  border-color: rgb(156 121 65 / 0.4);
}
.hover\\:border-\\[\\#9C7941\\]\\/50:hover{
  border-color: rgb(156 121 65 / 0.5);
}
.hover\\:border-\\[\\#EBD38D\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(235 211 141 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#EBD38D\\]\\/50:hover{
  border-color: rgb(235 211 141 / 0.5);
}
.hover\\:border-\\[\\#EBD38D\\]\\/60:hover{
  border-color: rgb(235 211 141 / 0.6);
}
.hover\\:bg-\\[\\#1a1d24\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(26 29 36 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1e2028\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 32 40 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#9C7941\\]\\/10:hover{
  background-color: rgb(156 121 65 / 0.1);
}
.hover\\:bg-\\[\\#9C7941\\]\\/20:hover{
  background-color: rgb(156 121 65 / 0.2);
}
.hover\\:bg-\\[\\#9C7941\\]\\/30:hover{
  background-color: rgb(156 121 65 / 0.3);
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-green-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-red-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-white\\/5:hover{
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:bg-white\\/\\[0\\.03\\]:hover{
  background-color: rgb(255 255 255 / 0.03);
}
.hover\\:text-\\[\\#8A8B90\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(138 139 144 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#EBD38D\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(235 211 141 / var(--tw-text-opacity, 1));
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-blue-400:hover{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-500:hover{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-pink-400:hover{
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}
.hover\\:text-red-300:hover{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:no-underline:hover{
  text-decoration-line: none;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:shadow-\\[0_0_28px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.4\\)\\]:hover{
  --tw-shadow: 0 0 28px rgba(156,121,65,0.4);
  --tw-shadow-colored: 0 0 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_0_50px_rgba\\(156\\2c 121\\2c 65\\2c 0\\.5\\)\\]:hover{
  --tw-shadow: 0 0 50px rgba(156,121,65,0.5);
  --tw-shadow-colored: 0 0 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-0:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-70:disabled{
  opacity: 0.7;
}
.group:hover .group-hover\\:w-full{
  width: 100%;
}
.group:hover .group-hover\\:translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-\\[\\#9C7941\\]\\/20{
  background-color: rgb(156 121 65 / 0.2);
}
.group:hover .group-hover\\:from-\\[\\#9C7941\\]\\/10{
  --tw-gradient-from: rgb(156 121 65 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 121 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.group:hover .group-hover\\:from-\\[\\#9C7941\\]\\/5{
  --tw-gradient-from: rgb(156 121 65 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 121 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.group:hover .group-hover\\:to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.group:hover .group-hover\\:text-\\[\\#4A4B50\\]{
  --tw-text-opacity: 1;
  color: rgb(74 75 80 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#9C7941\\]\\/20{
  color: rgb(156 121 65 / 0.2);
}
.group:hover .group-hover\\:text-\\[\\#9C7941\\]\\/30{
  color: rgb(156 121 65 / 0.3);
}
.group:hover .group-hover\\:text-\\[\\#EBD38D\\]{
  --tw-text-opacity: 1;
  color: rgb(235 211 141 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-5{
  opacity: 0.05;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[state\\=open\\]\\:border-\\[\\#9C7941\\]\\/50[data-state="open"]{
  border-color: rgb(156 121 65 / 0.5);
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-24{
    height: 6rem;
  }

  .sm\\:h-32{
    height: 8rem;
  }

  .sm\\:h-36{
    height: 9rem;
  }

  .sm\\:h-\\[180px\\]{
    height: 180px;
  }

  .sm\\:h-\\[200px\\]{
    height: 200px;
  }

  .sm\\:h-\\[220px\\]{
    height: 220px;
  }

  .sm\\:h-\\[240px\\]{
    height: 240px;
  }

  .sm\\:h-\\[260px\\]{
    height: 260px;
  }

  .sm\\:h-\\[280px\\]{
    height: 280px;
  }

  .sm\\:h-\\[300px\\]{
    height: 300px;
  }

  .sm\\:h-\\[320px\\]{
    height: 320px;
  }

  .sm\\:h-\\[380px\\]{
    height: 380px;
  }

  .sm\\:h-\\[400px\\]{
    height: 400px;
  }

  .sm\\:h-\\[420px\\]{
    height: 420px;
  }

  .sm\\:h-\\[620px\\]{
    height: 620px;
  }

  .sm\\:min-h-\\[360px\\]{
    min-height: 360px;
  }

  .sm\\:min-h-\\[420px\\]{
    min-height: 420px;
  }

  .sm\\:w-10{
    width: 2.5rem;
  }

  .sm\\:w-24{
    width: 6rem;
  }

  .sm\\:w-32{
    width: 8rem;
  }

  .sm\\:w-36{
    width: 9rem;
  }

  .sm\\:w-40{
    width: 10rem;
  }

  .sm\\:w-\\[180px\\]{
    width: 180px;
  }

  .sm\\:w-\\[200px\\]{
    width: 200px;
  }

  .sm\\:w-\\[220px\\]{
    width: 220px;
  }

  .sm\\:w-\\[240px\\]{
    width: 240px;
  }

  .sm\\:w-\\[260px\\]{
    width: 260px;
  }

  .sm\\:w-\\[280px\\]{
    width: 280px;
  }

  .sm\\:w-\\[300px\\]{
    width: 300px;
  }

  .sm\\:w-\\[320px\\]{
    width: 320px;
  }

  .sm\\:w-\\[380px\\]{
    width: 380px;
  }

  .sm\\:w-\\[400px\\]{
    width: 400px;
  }

  .sm\\:w-\\[420px\\]{
    width: 420px;
  }

  .sm\\:w-\\[620px\\]{
    width: 620px;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:flex-initial{
    flex: 0 1 auto;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:gap-8{
    gap: 2rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:self-auto{
    align-self: auto;
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:pb-10{
    padding-bottom: 2.5rem;
  }

  .sm\\:pb-12{
    padding-bottom: 3rem;
  }

  .sm\\:pt-32{
    padding-top: 8rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-base{
    font-size: 1.0625rem;
    line-height: 1.75;
  }

  .sm\\:text-lg{
    font-size: 1.1875rem;
    line-height: 1.75;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.3125rem;
    line-height: 1.75;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:bottom-10{
    bottom: 2.5rem;
  }

  .md\\:left-0{
    left: 0px;
  }

  .md\\:left-1\\/2{
    left: 50%;
  }

  .md\\:left-10{
    left: 2.5rem;
  }

  .md\\:right-0{
    right: 0px;
  }

  .md\\:right-10{
    right: 2.5rem;
  }

  .md\\:top-10{
    top: 2.5rem;
  }

  .md\\:mb-16{
    margin-bottom: 4rem;
  }

  .md\\:mb-24{
    margin-bottom: 6rem;
  }

  .md\\:ml-0{
    margin-left: 0px;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-10{
    height: 2.5rem;
  }

  .md\\:h-28{
    height: 7rem;
  }

  .md\\:h-40{
    height: 10rem;
  }

  .md\\:h-44{
    height: 11rem;
  }

  .md\\:h-96{
    height: 24rem;
  }

  .md\\:h-\\[220px\\]{
    height: 220px;
  }

  .md\\:h-\\[250px\\]{
    height: 250px;
  }

  .md\\:h-\\[280px\\]{
    height: 280px;
  }

  .md\\:h-\\[300px\\]{
    height: 300px;
  }

  .md\\:h-\\[340px\\]{
    height: 340px;
  }

  .md\\:h-\\[380px\\]{
    height: 380px;
  }

  .md\\:h-\\[400px\\]{
    height: 400px;
  }

  .md\\:h-\\[450px\\]{
    height: 450px;
  }

  .md\\:h-\\[500px\\]{
    height: 500px;
  }

  .md\\:h-\\[800px\\]{
    height: 800px;
  }

  .md\\:w-1\\/2{
    width: 50%;
  }

  .md\\:w-10{
    width: 2.5rem;
  }

  .md\\:w-28{
    width: 7rem;
  }

  .md\\:w-40{
    width: 10rem;
  }

  .md\\:w-44{
    width: 11rem;
  }

  .md\\:w-\\[220px\\]{
    width: 220px;
  }

  .md\\:w-\\[250px\\]{
    width: 250px;
  }

  .md\\:w-\\[280px\\]{
    width: 280px;
  }

  .md\\:w-\\[300px\\]{
    width: 300px;
  }

  .md\\:w-\\[340px\\]{
    width: 340px;
  }

  .md\\:w-\\[380px\\]{
    width: 380px;
  }

  .md\\:w-\\[400px\\]{
    width: 400px;
  }

  .md\\:w-\\[450px\\]{
    width: 450px;
  }

  .md\\:w-\\[500px\\]{
    width: 500px;
  }

  .md\\:w-\\[800px\\]{
    width: 800px;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-start{
    justify-content: flex-start;
  }

  .md\\:justify-end{
    justify-content: flex-end;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-12{
    gap: 3rem;
  }

  .md\\:gap-16{
    gap: 4rem;
  }

  .md\\:gap-2{
    gap: 0.5rem;
  }

  .md\\:gap-5{
    gap: 1.25rem;
  }

  .md\\:gap-6{
    gap: 1.5rem;
  }

  .md\\:gap-8{
    gap: 2rem;
  }

  .md\\:self-auto{
    align-self: auto;
  }

  .md\\:p-10{
    padding: 2.5rem;
  }

  .md\\:p-12{
    padding: 3rem;
  }

  .md\\:p-16{
    padding: 4rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:py-28{
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .md\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .md\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:pl-16{
    padding-left: 4rem;
  }

  .md\\:pr-16{
    padding-right: 4rem;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-base{
    font-size: 1.0625rem;
    line-height: 1.75;
  }

  .md\\:text-lg{
    font-size: 1.1875rem;
    line-height: 1.75;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl{
    font-size: 1.3125rem;
    line-height: 1.75;
  }

  .md\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 1024px){

  .lg\\:absolute{
    position: absolute;
  }

  .lg\\:bottom-16{
    bottom: 4rem;
  }

  .lg\\:bottom-6{
    bottom: 1.5rem;
  }

  .lg\\:left-0{
    left: 0px;
  }

  .lg\\:right-0{
    right: 0px;
  }

  .lg\\:top-16{
    top: 4rem;
  }

  .lg\\:order-1{
    order: 1;
  }

  .lg\\:order-2{
    order: 2;
  }

  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-start-2{
    grid-column-start: 2;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:grid{
    display: grid;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-\\[280px\\]{
    height: 280px;
  }

  .lg\\:h-\\[310px\\]{
    height: 310px;
  }

  .lg\\:h-\\[320px\\]{
    height: 320px;
  }

  .lg\\:h-\\[380px\\]{
    height: 380px;
  }

  .lg\\:h-\\[450px\\]{
    height: 450px;
  }

  .lg\\:min-h-0{
    min-height: 0px;
  }

  .lg\\:w-\\[280px\\]{
    width: 280px;
  }

  .lg\\:w-\\[310px\\]{
    width: 310px;
  }

  .lg\\:w-\\[320px\\]{
    width: 320px;
  }

  .lg\\:w-\\[380px\\]{
    width: 380px;
  }

  .lg\\:w-\\[450px\\]{
    width: 450px;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[280px_1fr\\]{
    grid-template-columns: 280px 1fr;
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:gap-12{
    gap: 3rem;
  }

  .lg\\:gap-20{
    gap: 5rem;
  }

  .lg\\:space-y-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(4rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(4rem * var(--tw-space-y-reverse));
  }

  .lg\\:divide-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }

  .lg\\:p-10{
    padding: 2.5rem;
  }

  .lg\\:p-16{
    padding: 4rem;
  }

  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .lg\\:pb-0{
    padding-bottom: 0px;
  }

  .lg\\:pl-12{
    padding-left: 3rem;
  }

  .lg\\:pr-12{
    padding-right: 3rem;
  }

  .lg\\:text-right{
    text-align: right;
  }

  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }
}
@media (min-width: 1280px){

  .xl\\:w-\\[260px\\]{
    width: 260px;
  }

  .xl\\:w-\\[380px\\]{
    width: 380px;
  }

  .xl\\:gap-10{
    gap: 2.5rem;
  }

  .xl\\:gap-24{
    gap: 6rem;
  }

  .xl\\:gap-28{
    gap: 7rem;
  }

  .xl\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:py-36{
    padding-top: 9rem;
    padding-bottom: 9rem;
  }

  .xl\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;IAAA,uBAAc;IAAd,uBAAc;IAAd,iBAAc;IAAd,4BAAc;IAAd,oBAAc;IAAd,+BAAc;IAAd,kBAAc;IAAd,8BAAc;IAAd,uBAAc;IAAd,+BAAc;IAAd,mBAAc;IAAd,8BAAc;IAAd,oBAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,kCAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,iBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,qBAAc;IAAd,gBAAc;EAAA;;AAAd;EAAA;AAAc;;AAAd,+DAAc;;AAAd;IAAA,yBAAc;IAAd,cAAc;EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,2FAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAIjB;IACE,wBAAwB;IACxB,qBAAqB;IACrB,wCAAwC;IACxC,kBAAkB;EACpB;AACA;;IAEE,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;EACzB;AACA;;;IAGE,aAAa;IACb,QAAQ;IACR,SAAS;IACT,uBAAuB;EACzB;;AAtBF,wDAAwD;;AAyBxD,0FAA0F;;AAE1F,wBAAwB;AACxB;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE;IACE,oCAAoC;IAEpC,oCAAoC;EACtC;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,+EAA+E;EAC/E,mCAAmC;EACnC,4BAA4B;EAC5B,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sFAAsF;EACtF,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;;;;EAQE;AACF;EACE,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,yDAA4T;EAC5T,UAAU,EAAE,uDAAuD;AACrE;;AAqEA;;;EAGE;AACF;EACE,wCAAwC;EACxC,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;AACf;;AAEA,gGAAgG;AAChG;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;;EAEE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA,wEAAwE;AACxE;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;AA/bA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,mBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA,QAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA,sBAgcA;EAhcA;AAgcA;AAhcA;EAAA,iDAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,kDAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,sBAgcA;EAhcA;AAgcA;AAhcA;EAAA,kBAgcA;EAhcA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA,kBAgcA;EAhcA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,sBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,0CAgcA;EAhcA,oDAgcA;EAhcA;AAgcA;AAhcA;EAAA,0CAgcA;EAhcA,oDAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,8BAgcA;EAhcA;AAgcA;AAhcA;EAAA,2GAgcA;EAhcA,yGAgcA;EAhcA;AAgcA;AAhcA;EAAA,2GAgcA;EAhcA,yGAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,8BAgcA;EAhcA;AAgcA;AAhcA;EAAA,2GAgcA;EAhcA,yGAgcA;EAhcA;AAgcA;AAhcA;EAAA,2GAgcA;EAhcA,yGAgcA;EAhcA;AAgcA;AAhcA;EAAA,2GAgcA;EAhcA,yGAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,yBAgcA;EAhcA;AAgcA;AAhcA;EAAA,kBAgcA;EAhcA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA,iBAgcA;EAhcA,iBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,0EAgcA;EAhcA,oEAgcA;EAhcA;AAgcA;AAhcA;EAAA,2EAgcA;EAhcA,oEAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,+EAgcA;EAhcA,mGAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,yBAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA;AAgcA;AAhcA;EAAA,yBAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA;AAgcA;AAhcA;EAAA,sBAgcA;EAhcA;AAgcA;AAhcA;EAAA,qBAgcA;EAhcA;AAgcA;AAhcA;EAAA,qBAgcA;EAhcA;AAgcA;AAhcA;EAAA,gDAgcA;EAhcA;AAgcA;AAhcA;EAAA,iDAgcA;EAhcA;AAgcA;AAhcA;;EAAA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;AAAA;AAhcA;EAAA;AAgcA;AAhcA;;EAAA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;AAAA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,0EAgcA;EAhcA,8FAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,qBAgcA;EAhcA,yBAgcA;EAhcA,2BAgcA;EAhcA,yBAgcA;EAhcA,0BAgcA;EAhcA,+BAgcA;EAhcA;AAgcA;AAhcA;EAAA,qBAgcA;EAhcA,yBAgcA;EAhcA,2BAgcA;EAhcA,yBAgcA;EAhcA,0BAgcA;EAhcA,+BAgcA;EAhcA;AAgcA;AAhcA;EAAA,qBAgcA;EAhcA,yBAgcA;EAhcA,2BAgcA;EAhcA,yBAgcA;EAhcA,0BAgcA;EAhcA,+BAgcA;EAhcA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA,yBAgcA;EAhcA,0BAgcA;EAhcA,wBAgcA;EAhcA,yBAgcA;EAhcA,8BAgcA;EAhcA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA,yBAgcA;EAhcA,0BAgcA;EAhcA,wBAgcA;EAhcA,yBAgcA;EAhcA,8BAgcA;EAhcA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA,yBAgcA;EAhcA,0BAgcA;EAhcA,wBAgcA;EAhcA,yBAgcA;EAhcA,8BAgcA;EAhcA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA,yBAgcA;EAhcA,0BAgcA;EAhcA,wBAgcA;EAhcA,yBAgcA;EAhcA,8BAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA,sBAgcA;EAhcA;AAgcA;AAhcA;EAAA,0BAgcA;EAhcA,qBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,mBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;;EAAA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,uBAgcA;IAhcA,sDAgcA;IAhcA;EAgcA;;EAhcA;IAAA,uBAgcA;IAhcA,oDAgcA;IAhcA;EAgcA;;EAhcA;IAAA,uBAgcA;IAhcA,2DAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,qBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,oBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,qBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,mBAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,eAgcA;IAhcA;EAgcA;;EAhcA;IAAA,oBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,oBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,mBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,oBAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;AAAA;AAhcA;;EAAA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,oBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,oBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,iBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,iBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,iBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,mBAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,iBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,mBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,eAgcA;IAhcA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,oBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,oBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,mBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,oBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;AAAA;AAhcA;;EAAA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,uBAgcA;IAhcA,4DAgcA;IAhcA;EAgcA;;EAhcA;IAAA,wBAgcA;IAhcA,kEAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,iBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,gBAgcA;IAhcA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,mBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,eAgcA;IAhcA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;AAAA;AAhcA;;EAAA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA;EAgcA;;EAhcA;IAAA,kBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,iBAgcA;IAhcA;EAgcA;;EAhcA;IAAA,iBAgcA;IAhcA;EAgcA;AAAA;AAhcA;EAAA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA,kDAgcA;EAhcA;AAgcA;AAhcA;EAAA,iDAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,iDAgcA;EAhcA;AAgcA;AAhcA;EAAA,kDAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,kDAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,qBAgcA;EAhcA;AAgcA;AAhcA;EAAA,gBAgcA;EAhcA,oBAgcA;EAhcA,4BAgcA;EAhcA;AAgcA;AAhcA;EAAA,sBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,WAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA,mBAgcA;EAhcA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA,qBAgcA;EAhcA;AAgcA;AAhcA;EAAA,kBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA,oBAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA,WAgcA;EAhcA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA;AAhcA;EAAA;AAgcA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* scrollbar-hide utility (used in trading components) */\n@layer utilities {\n  .scrollbar-hide {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    scrollbar-color: transparent transparent;\n    color-scheme: dark;\n  }\n  .scrollbar-hide::-webkit-scrollbar,\n  .scrollbar-hide::-webkit-scrollbar-corner {\n    width: 0;\n    height: 0;\n    display: none;\n    background: transparent;\n  }\n  .scrollbar-hide::-webkit-scrollbar-thumb,\n  .scrollbar-hide::-webkit-scrollbar-track,\n  .scrollbar-hide::-webkit-scrollbar-button {\n    display: none;\n    width: 0;\n    height: 0;\n    background: transparent;\n  }\n}\n\n/* Order book list classes — see unlayered block at end of file (must win over Tailwind) */\n\n/* Hide Emergent badge */\n#emergent-badge {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n}\n\n/* PDF print styles */\n@media print {\n  body {\n    background-color: #0a0b0d !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n  \n  .pdf-section {\n    page-break-inside: avoid;\n  }\n}\n\n:root {\n  --brand-primary: #9C7941;\n  --brand-secondary: #EBD38D;\n  --brand-dark: #1B1E20;\n  --brand-gray: #4A4B50;\n  --brand-silver: #D5D5D0;\n  --bg-default: #1B1E20;\n  --bg-paper: #232628;\n  --text-primary: #FFFFFF;\n  --text-secondary: #D5D5D0;\n  --text-muted: #8A8B90;\n  --text-accent: #EBD38D;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  font-size: 15px;\n}\n\n@media (min-width: 640px) {\n  html {\n    font-size: 16px;\n  }\n}\n\n@media (min-width: 1280px) {\n  html {\n    font-size: 17px;\n  }\n}\n\n@media (max-width: 639px) {\n  [id] {\n    scroll-margin-top: 88px;\n  }\n}\n\nbody {\n  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n  background-color: var(--bg-default);\n  color: var(--text-secondary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Outfit', sans-serif;\n}\n\ncode, pre {\n  font-family: 'JetBrains Mono', monospace;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-default);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--brand-gray);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--brand-primary);\n}\n\n/* Selection */\n::selection {\n  background: var(--brand-primary);\n  color: var(--brand-dark);\n}\n\n/* Animations */\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-20px) rotate(2deg);\n  }\n}\n\n@keyframes pulse-glow {\n  0%, 100% {\n    box-shadow: 0 0 20px rgba(156, 121, 65, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 40px rgba(156, 121, 65, 0.6);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@keyframes gradient-shift {\n  0%, 100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n@keyframes ticker {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.animate-float {\n  animation: float 6s ease-in-out infinite;\n}\n\n.animate-pulse-glow {\n  animation: pulse-glow 2s ease-in-out infinite;\n}\n\n.animate-shimmer {\n  background: linear-gradient(90deg, transparent, rgba(235, 211, 141, 0.1), transparent);\n  background-size: 200% 100%;\n  animation: shimmer 2s infinite;\n}\n\n.animate-gradient {\n  background-size: 200% 200%;\n  animation: gradient-shift 3s ease infinite;\n}\n\n.animate-ticker {\n  animation: ticker 30s linear infinite;\n}\n\n/* Glass morphism */\n.glass {\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  background: rgba(27, 30, 32, 0.7);\n  border: 1px solid rgba(235, 211, 141, 0.1);\n}\n\n.glass-hover:hover {\n  background: rgba(27, 30, 32, 0.85);\n  border-color: rgba(235, 211, 141, 0.3);\n}\n\n/* Gold gradient text */\n.text-gold-gradient {\n  background: linear-gradient(135deg, #FFFFFF 0%, #EBD38D 50%, #9C7941 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Gold border glow */\n.border-gold-glow {\n  border: 1px solid rgba(156, 121, 65, 0.3);\n  box-shadow: 0 0 20px rgba(156, 121, 65, 0.15);\n}\n\n/* Button styles */\n.btn-primary {\n  background: linear-gradient(135deg, #9C7941 0%, #EBD38D 100%);\n  color: #1B1E20;\n  font-weight: 700;\n  padding: 1rem 2rem;\n  border-radius: 9999px;\n  transition: all 0.3s ease;\n  box-shadow: 0 0 20px rgba(156, 121, 65, 0.4);\n}\n\n.btn-primary:hover {\n  transform: scale(1.05);\n  box-shadow: 0 0 30px rgba(156, 121, 65, 0.6);\n}\n\n.btn-secondary {\n  background: transparent;\n  border: 2px solid #EBD38D;\n  color: #EBD38D;\n  font-weight: 700;\n  padding: 1rem 2rem;\n  border-radius: 9999px;\n  transition: all 0.3s ease;\n}\n\n.btn-secondary:hover {\n  background: rgba(235, 211, 141, 0.1);\n}\n\n/*\n * Fixed header height:\n *   announcement strip  ≈ 36px  (h-9)\n *   main nav (scrolled) ≈ 56px  (py-3 + ~40px content)\n *   total               ≈ 92px  → use 100px for buffer\n *\n * All section IDs get scroll-margin-top so the fixed header\n * doesn't cover them when an anchor link scrolls to them.\n */\n[id] {\n  scroll-margin-top: 100px;\n}\n\n/* Section styling */\n.section-padding {\n  padding: 4rem 1rem;\n}\n\n@media (min-width: 640px) {\n  .section-padding {\n    padding: 5rem 1.5rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .section-padding {\n    padding: 7rem 4rem;\n  }\n}\n\n@media (min-width: 1280px) {\n  .section-padding {\n    padding: 8rem 5rem;\n  }\n}\n\n/* Card styling */\n.card-glass {\n  background: rgba(27, 30, 32, 0.5);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(74, 75, 80, 0.3);\n  border-radius: 1rem;\n  transition: all 0.3s ease;\n}\n\n.card-glass:hover {\n  border-color: rgba(156, 121, 65, 0.5);\n  transform: translateY(-4px);\n}\n\n/* Noise overlay */\n.noise-overlay::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  opacity: 0.02;\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\");\n  z-index: 1; /* Keep below modals, dropdowns, and fixed nav (z-50) */\n}\n\n@layer base {\n  :root {\n    --background: 0 0% 100%;\n    --foreground: 0 0% 3.9%;\n    --card: 0 0% 100%;\n    --card-foreground: 0 0% 3.9%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 0 0% 3.9%;\n    --primary: 0 0% 9%;\n    --primary-foreground: 0 0% 98%;\n    --secondary: 0 0% 96.1%;\n    --secondary-foreground: 0 0% 9%;\n    --muted: 0 0% 96.1%;\n    --muted-foreground: 0 0% 45.1%;\n    --accent: 0 0% 96.1%;\n    --accent-foreground: 0 0% 9%;\n    --destructive: 0 84.2% 60.2%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 0 0% 89.8%;\n    --input: 0 0% 89.8%;\n    --ring: 0 0% 3.9%;\n    --chart-1: 12 76% 61%;\n    --chart-2: 173 58% 39%;\n    --chart-3: 197 37% 24%;\n    --chart-4: 43 74% 66%;\n    --chart-5: 27 87% 67%;\n    --radius: 0.5rem;\n  }\n  .dark {\n    --background: 0 0% 3.9%;\n    --foreground: 0 0% 98%;\n    --card: 0 0% 3.9%;\n    --card-foreground: 0 0% 98%;\n    --popover: 0 0% 3.9%;\n    --popover-foreground: 0 0% 98%;\n    --primary: 0 0% 98%;\n    --primary-foreground: 0 0% 9%;\n    --secondary: 0 0% 14.9%;\n    --secondary-foreground: 0 0% 98%;\n    --muted: 0 0% 14.9%;\n    --muted-foreground: 0 0% 63.9%;\n    --accent: 0 0% 14.9%;\n    --accent-foreground: 0 0% 98%;\n    --destructive: 0 62.8% 30.6%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 0 0% 14.9%;\n    --input: 0 0% 14.9%;\n    --ring: 0 0% 83.1%;\n    --chart-1: 220 70% 50%;\n    --chart-2: 160 60% 45%;\n    --chart-3: 30 80% 55%;\n    --chart-4: 280 65% 60%;\n    --chart-5: 340 75% 55%;\n  }\n}\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n  /* Override shadcn default body to keep the dark crypto theme */\n  body {\n    background-color: #0a0b0d;\n    color: #D5D5D0;\n  }\n}\n\n/*\n * Order book — Radix ScrollArea injects scrollbar-hiding CSS on the viewport.\n * These rules handle text selection + tap highlight (white “flash” on Windows).\n */\n.order-book-root {\n  -webkit-tap-highlight-color: transparent;\n  color-scheme: dark;\n  -webkit-touch-callout: none;\n  overflow: hidden;\n  min-height: 0;\n}\n\n/* Wheel-scroll viewports: no native scrollbar (Windows often shows a bright track otherwise). */\n.ob-viewport {\n  overflow: hidden !important;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.ob-viewport::-webkit-scrollbar {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n.order-book-row {\n  -webkit-tap-highlight-color: transparent;\n  contain: layout paint;\n}\n\n.order-book-row,\n.order-book-row * {\n  user-select: none !important;\n  -webkit-user-select: none !important;\n}\n\n.order-book-root ::selection,\n.order-book-root *::selection {\n  background: transparent !important;\n  color: inherit !important;\n}\n\n.order-book-mid {\n  user-select: none !important;\n  -webkit-user-select: none !important;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Wheel-scroll inner layer (no native overflow = no scrollbar gutter) */\n.order-book-wheel-content {\n  user-select: none !important;\n  -webkit-user-select: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
